<template>
  <section class="table-section disp-scroll">
    <table class="sended-list-table" border="1">
      <tr class="table-header">
        <th class="to">宛先</th>
        <th class="subject">件名</th>
        <th class="detail">詳細</th>
        <th class="deliver">受信</th>
        <th class="open">開封</th>
        <th class="link">リンク</th>
        <th class="created-at">送付日時</th>
      </tr>
      <template v-for="(sended, i) in sendedEmailList">
        <tr :key="i">
          <td v-if="sended.is_received">{{user.companyName}}</td>
          <td v-else>{{sended.name}}</td>
          <td class="subject">
            {{sended.email_subject}}
          </td>
          <td>
            <div class="center-item-wrapper">
              <button class="button is-small"
                @click="clickEmailDetailButton(sended)">
                確認
              </button>
            </div>
          </td>
          <td>
            <div class="check"><span v-if="sended.is_deliver">○</span></div>
          </td>
          <td>
            <div class="check"><span v-if="sended.is_open">○</span></div>
          </td>
          <td>
            <div class="check"><span v-if="sended.is_link">○</span></div>
          </td>
          <td>{{formatTime(sended.created_at)}}</td>
        </tr>
      </template>
    </table>
  </section>
</template>

<script>
export default {
  props: {
    sendedEmailList: {
      type: Array,
      required: false,
    },
    user: {
      type: Object,
      required: false
    }
  },
  methods: {
    formatTime (createdAt) {
      return this.$moment(createdAt).format('YYYY/MM/DD H:mm:ss')
    },
    clickEmailDetailButton (sended) {
      this.$emit('clickEmailDetailButton', sended)
    }
  },
}
</script>

<style lang="scss" scoped>
.sended-list-table {
  font-size: 12px;
  width: 100%;
  table-layout: fixed;
  th, td {
    padding: 8px;
  }
  .to {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .subject {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .detail {
    width: 64px;
  }
  .deliver, .open, .link {
    width: 56px;
  }
  .created-at {
    width: 144px;
  }
  .check {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .center-item-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.empty-tr {
  height: 36px;
}
td {
  word-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/tables/EmailLogTable.vue